<template>
    <div class="estate-content">
        <div class="row">
            <template v-if="$root.is_mobile">
                <slot name="title" />

                <slot name="subtitle" />
            </template>
        </div>
        <div class="row">
            <related-estates
                :estate="estate"
            >
            </related-estates>
        </div>
        <div class="row border-radius bg-white padding-flex mb-1">
            <div class="col-md-6 estate-features">
                <!-- <span v-if='estate.top'>{{ trans('labels.top') }}!!!</span> -->
                <span v-if='estate.exclusive'>{{ trans('labels.exclusive') }}!!!</span>
                <h2>
                    <masked-image class="icon_title" src="/img/icons/features.svg"></masked-image>
                    {{ trans('labels.features') | capitalize }}
                </h2>

                <div class="text-left" v-if="$root.is_mobile && estate.pdf">
                    <a
                        :href="estate.pdf"
                        target="_blank" rel="noopener" class="print-pdf"
                    >
                        <!-- <img
                            src="/img/icons/pdf-file-red.svg"
                            :alt="trans('labels.print') | capitalize"
                        > -->
                        {{ trans('labels.print') }}
                    </a>
                </div>

                <template v-for="(value, feature) in firstFeatures">
                    <div v-if="feature" class="row" :key="feature">
                        <div class="col">
                            <strong>{{ trans('features.' + feature) | capitalize }}:</strong>
                        </div>
    
                        <div class="col">
                            {{ value }}
                        </div>
                    </div>
                </template>  

                <modal-opener
                    v-if="featuresCount > features_count"
                    name="features"
                    class="features"
                >
                    <button class="btn btn-text" :class="'btn-text-' + estate.network">
                        {{ trans('labels.show_more') }}
                    </button>
                </modal-opener>

                <modal
                    name="features"
                    ref="features"
                    extra-class="full-screen-modal features-modal"
                    :title="trans('labels.features') | capitalize"
                    icon= "features.svg"
                >
                    <template slot="body">
                        <slot name="features" />
                    </template>
                </modal>
            </div>

            <div class="col-md-6 p-0">
                <div class="text-right" v-if="!$root.is_mobile && estate.pdf">
                    <a
                        :href="estate.pdf"
                        target="_blank"
                        rel="nofollow"
                        class="print-pdf"
                    >
                        {{ trans('labels.print') }}
                    </a>
                </div>

                <div v-if="costs" class="estate-costs">
                    <h3>{{ trans('labels.costs') | capitalize }}</h3>

                    <show-more>
                        <slot name="costs" />
                    </show-more>

                    <div v-if="estate.estate_other_contract" class="row">
                        <div class="col">
                            <masked-image src="/img/icons/icon-rent.svg" class="costs-details"></masked-image>
                            {{ lang.labels.also }} {{ $root.lang.words.contract[estate.estate_other_contract.contract] }} {{ lang.labels.to }}
                        </div>
                        <div class="col">
                            <a :href="estate.estate_other_contract.detail_url" target="_blank">
                                <span v-html="estate.estate_other_contract.price"></span>
                                <masked-image src="/img/icons/linear-arrow-right.svg" class="costs-details" width="13" height="13"></masked-image>
                            </a>
                        </div>
                    </div>

                    <div v-if="showCalculateMortgage" class="row buttons">
                        <modal-opener
                            v-if="config_estate.custom_offer"
                            name="custom-offer"
                        >
                            <button class="btn">
                                <masked-image src="/img/icons/price-proposal.svg"></masked-image>
                                {{ trans('labels.custom_offer') }}
                            </button>
                        </modal-opener>

                        <modal-opener
                            name="calculate-mortgage"
                            class="calculate-mortgage"
                        >
                            <button class="btn">
                                <masked-image src="/img/icons/calculate.svg"></masked-image>
                                {{ trans('labels.calculate_mortgage') }}
                            </button>
                        </modal-opener>
                    </div>
                    <div v-if="estate.tecnovalore" class="row">
                        <div class="p-2 tecnovalore">
                            <img src="/img/logo/logo-tecnovalore.png" class="logo-tecnovalore" width="29" height="30"/>
                            {{ trans('labels.tecnovalore') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="estate.description"
            class="row border-radius bg-white padding-flex mb-1"
        >
            <div :class="estate.points_of_interest ? 'col-6 estate-description' : 'col-12'" >
            <!-- <div class="col-md-6 estate-description"> -->
                <h2>
                    <masked-image class="icon_title" src="/img/icons/description.svg"></masked-image>
                    {{ trans('labels.description') | capitalize }}
                </h2>

                <div class="estate-description-container">
                    <slot name="description" />
                </div>
                
                <modal-opener
                    v-if="descriptionIsLong"
                    name="description"
                    class="description"
                >
                    <button class="btn btn-text" :class="'btn-text-' + estate.network">
                        {{ trans('labels.show_more') }}
                    </button>
                </modal-opener>

                <modal
                    name="description"
                    ref="description"
                    extra-class="full-screen-modal description-modal"
                    :title="trans('labels.description') | capitalize"
                    icon= "description.svg"
                >
                    <template slot="body">
                        <div class="open-sign text-left">
                            <img src="/img/icons/edit-descr.svg" class="dec"/>
                        </div>

                        <div class="px-2" v-html="estate.description"></div>

                        <div class="close-sign text-right">
                            <img src="/img/icons/edit-descr.svg" class="dec"/>
                        </div>
                    </template>
                </modal>
            </div>

            <div
                v-if="estate.points_of_interest"
                class="col-md-6 p-0"
            >
                <div class="estate-points-of-interest">
                    <h3>{{ trans('labels.points_of_interest') | capitalize }}</h3>

                    <div class="points-of-interest-container">
                        <points-of-interest-list :poi="estate.points_of_interest" />
                    </div>

                    <modal-opener
                        name="points-of-interest"
                        class="points-of-interest"
                    >
                        <button class="btn btn-text" :class="'btn-text-' + estate.network">
                            {{ trans('labels.show_more') }}
                        </button>
                    </modal-opener>

                    <modal
                        name="points-of-interest"
                        ref="points-of-interest"
                        extra-class="full-screen-modal points-of-interest-modal"
                        :title="trans('labels.points_of_interest') | capitalize"
                    >
                        <template slot="body">
                            <points-of-interest-list :poi="estate.points_of_interest" />
                        </template>
                    </modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Modal from '../Modal'
import ModalOpener from '../ModalOpener'
import PointsOfInterestList from './PointsOfInterestList'
import ShowMore from '../ShowMore'
import RelatedEstates from './RelatedEstates'

import { countObject, filterObject, sliceObject } from '../../helpers/objects'

export default {
    components: {
        'modal': Modal,
        'modal-opener': ModalOpener,
        'points-of-interest-list': PointsOfInterestList,
        'show-more': ShowMore,
        'related-estates': RelatedEstates
    },

    props: {
        config_estate: {
            type: Object,
            required: true,
        },

        estate: {
            type: Object,
            required: true,
        },

        showCalculateMortgage: {
            type: Boolean,
            defaullt: false,
        },
    },
    
    data() {
        return {
            description_length: 200,
            features_count: 6,
        }
    },

    computed: {
        costs() {
            if (!this.config_estate.costs) {
                return false
            }

            return filterObject(this.estate.costs, item => {
                return item
            })
        },

        descriptionIsLong() {
            return this.estate.description.length > this.description_length
        },

        firstFeatures() {
            let features = filterObject(this.estate.features, item => {
                return item
            })

            return sliceObject(features, 0, this.features_count)
        },

        featuresCount() {
            let features = filterObject(this.estate.features, item => {
                return item
            })

            return countObject(features)
        },

        lang() {
            return this.$root.lang.estate_detail
        },
    },
}
</script>